/**
 * Controls the behaviour of AccordionDesignTransformation
 * @type {AccordionDesignTransformation}
 */
export class AccordionDesignTransformation {
    constructor() {
        this.doms = document.querySelectorAll('.js__accordion-design-transformation')
        this.init()
    }

    /**
     * Initializes the interactions
     */
    init() {
        for (let i = 0; i < this.doms.length; i++) {
            let titleWrapper = this.doms[i].querySelector('.js__title-items-wrapper')
            let contents = this.doms[i].querySelectorAll('.js__collapse__design-transformation__content')
            let headlines = this.doms[i].querySelectorAll('.js__collapse__design-transformation__headline')

            // Interactions on mouse over
            titleWrapper.onmouseover = (event) => {
                let target = event.target

                if (target.classList.contains('js__collapse__design-transformation__headline')) {
                    // Show target headline hide others
                    for (var j = 0; j < headlines.length; j++) {
                        headlines[j].classList.remove('js__active')
                    }
                    target.classList.add('js__active')

                    let itemKey = target.dataset.itemKey

                    // Hide all contents
                    for (var k = 0; k < contents.length; k++) {
                        contents[k].classList.remove('js__active')
                    }

                    // Show target content
                    let showTarget = this.doms[i].querySelector(
                        `.js__collapse__design-transformation__content[data-item-key="${itemKey}"]`
                    )
                    showTarget.classList.add('js__active')
                }
            }
        }
    }
}
